var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCampaign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212,
    height: 212,
    viewBox: "0 0 212 212",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4292_3952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 212,
    height: 212
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.52588e-05H212V212H0V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4292_3952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4766 205.789H106.003V139.263H39.4766V205.789Z",
    stroke: "black",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7371 105.999H6.21094L39.4742 139.262H106L72.7371 105.999Z",
    stroke: "black",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 205.789H172.526V139.263H106V205.789Z",
    stroke: "black",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.789 105.999H139.263L106 139.262H172.526L205.789 105.999Z",
    stroke: "black",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.998 99.3477C105.998 99.3477 105.998 26.1692 66.0827 26.1692C32.8199 26.1692 32.8199 72.7371 79.3878 72.7371",
    stroke: "black",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.266 12.8648C185.834 12.8648 185.834 72.7383 125.961 72.7383",
    stroke: "black",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 6.21054L112.653 12.8633L119.305 6.21054",
    stroke: "black",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCampaign);
export default __webpack_public_path__ + "static/media/no-campaign.c5fab09a33d5f107fd1b988ea9dbafce.svg";
export { ForwardRef as ReactComponent };